import { render, staticRenderFns } from "./MgmModal.vue?vue&type=template&id=218b9e31&scoped=true&"
import script from "./MgmModal.vue?vue&type=script&lang=js&"
export * from "./MgmModal.vue?vue&type=script&lang=js&"
import style0 from "./MgmModal.vue?vue&type=style&index=0&id=218b9e31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b9e31",
  null
  
)

export default component.exports